import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";

const API_BASE = getApiBaseUrl();

export interface InfoMessage {
  id: number;
  type: 'tutorial' | 'notice' | 'update';
  // 閉じた後の再表示挙動（バックエンドが返す）。未指定なら 'once' 扱い。
  //   - once     : 一度閉じたら自動既読
  //   - cooldown : cooldown_days 経過後に再表示、max_displays 回で打ち止め
  //   - every    : 毎回表示（セッション中のみ抑制）
  redisplay_policy?: 'every' | 'once' | 'cooldown';
  page1_ja_title: string;
  page1_en_title?: string;
  page1_image_url?: string;
  page1_ja_body_text: string;
  page1_en_body_text?: string;
  page2_ja_title?: string;
  page2_en_title?: string;
  page2_image_url?: string;
  page2_ja_body_text?: string;
  page2_en_body_text?: string;
  page3_ja_title?: string;
  page3_en_title?: string;
  page3_image_url?: string;
  page3_ja_body_text?: string;
  page3_en_body_text?: string;
  ja_action_text?: string;
  en_action_text?: string;
  action_url?: string;
}

export async function getUnreadInfoMessages(token: string): Promise<InfoMessage[]> {
  return await apiFetch(`${API_BASE}/api/management/info-messages/unread`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
  });
};

/**
 * メッセージを「永久既読」にする。
 * 「今後表示しない」チェックON / once ポリシーで閉じた / アクションボタン押下 で呼ぶ。
 */
export async function markInfoMessageAsRead(token: string, id: number): Promise<boolean> {
    return await apiFetch(`${API_BASE}/api/management/info-messages/read/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
};

/**
 * メッセージをスヌーズ（一時非表示）する。
 * cooldown ポリシーのメッセージをチェックを付けずに閉じたときに呼ぶ。
 * 再表示可否（cooldown_days 経過 / max_displays 到達）はバックエンドが判定する。
 */
export async function snoozeInfoMessage(
    token: string,
    id: number
): Promise<{ success: boolean; display_count?: number }> {
    return await apiFetch(`${API_BASE}/api/management/info-messages/snooze/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
};
